import * as React from 'react';

const LactationIcon = ({ color = '#E01268' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7 9.6C14.9 9.2 15 8.9 15 8.5C15 7.2 14 6.1 12.7 6C12.5 5.2 12.4 4.3 12.4 3.4C12.4 2.1 11.6 1.1 10.5 1.1C9.4 1.1 8.6 2.1 8.6 3.4C8.6 4.3 8.5 5.1 8.3 6C7 6.1 6 7.2 6 8.5C6 8.9 6.1 9.2 6.3 9.6C5.5 10.1 5 11 5 12V16C5 18.2 6.8 20 9 20H12C14.2 20 16 18.2 16 16V12C16 11 15.5 10.1 14.7 9.6ZM10.5 3C10.6797 3 10.7539 3.2 10.7539 3.4C10.7539 4.2 10.7539 5.69375 10.8 6H10.2C10.2656 5.68203 10.2656 4.3 10.2656 3.4C10.2656 3.2 10.3203 3 10.5 3ZM8.5 8H12.5C12.8 8 13 8.2 13 8.5C13 8.8 12.8 9 12.5 9H8.5C8.2 9 8 8.8 8 8.5C8 8.2 8.2 8 8.5 8ZM14 16C14 17.1 13.1 18 12 18H9C7.9 18 7 17.1 7 16V15H8C8.6 15 9 14.6 9 14C9 13.4 8.6 13 8 13H7V12C7 11.4 7.4 11 8 11H8.5H12.5H13C13.6 11 14 11.4 14 12V13H11C10.4 13 10 13.4 10 14C10 14.6 10.4 15 11 15H14V16Z"
      fill={color}
    />
  </svg>
);
export default LactationIcon;
